import { render, staticRenderFns } from "./bindPhoneCheckout.vue?vue&type=template&id=5291db4e&scoped=true&"
import script from "./bindPhoneCheckout.vue?vue&type=script&lang=js&"
export * from "./bindPhoneCheckout.vue?vue&type=script&lang=js&"
import style0 from "./bindPhoneCheckout.vue?vue&type=style&index=0&id=5291db4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5291db4e",
  null
  
)

export default component.exports